import styled from '@emotion/styled';

/**
 * One of the two columns of the dialog's first row (colour + title, type).
 * The type-specific fields below use it too, so they line up with the colour
 * and title fields above them.
 */
export const HalfWidthField = styled('div')((p) => ({
  width: `calc(50% - ${p.theme.spacing(1)}px)`
}));
